import React from "react";

/* Icon set — translated from design/details-v5/details-v5-icons.jsx.
   All icons share a 24px viewBox, stroke = currentColor (outline-style). */

type IconC = React.FC;

export const Description: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="3" width="16" height="18" rx="2" />
    <line x1="8" y1="8" x2="16" y2="8" />
    <line x1="8" y1="12" x2="16" y2="12" />
    <line x1="8" y1="16" x2="13" y2="16" />
  </svg>
);

export const Amenities: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 20 L4 12 L8 8 L12 12 L12 20" />
    <path d="M12 20 L12 14 L16 10 L20 14 L20 20" />
    <line x1="3" y1="20" x2="21" y2="20" />
  </svg>
);

export const Location: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 21s-7-6.5-7-12a7 7 0 1 1 14 0c0 5.5-7 12-7 12z" />
    <circle cx="12" cy="9" r="2.5" />
  </svg>
);

export const Highlights: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 5 L4 19 L12 17 L20 19 L20 5 L12 7 Z" />
    <line x1="12" y1="7" x2="12" y2="17" />
  </svg>
);

export const UnitDetails: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="3" width="14" height="18" rx="1" />
    <line x1="9" y1="7" x2="9" y2="7.5" /><line x1="12" y1="7" x2="12" y2="7.5" /><line x1="15" y1="7" x2="15" y2="7.5" />
    <line x1="9" y1="11" x2="9" y2="11.5" /><line x1="12" y1="11" x2="12" y2="11.5" /><line x1="15" y1="11" x2="15" y2="11.5" />
    <line x1="9" y1="15" x2="9" y2="15.5" /><line x1="12" y1="15" x2="12" y2="15.5" /><line x1="15" y1="15" x2="15" y2="15.5" />
    <line x1="11" y1="18.5" x2="13" y2="18.5" />
  </svg>
);

export const Media: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="6" width="18" height="14" rx="2" />
    <path d="M8 6 L10 3 L14 3 L16 6" />
    <circle cx="12" cy="13" r="3.2" />
  </svg>
);

export const ChevronDown: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export const Eye: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const Close: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="6" y1="6" x2="18" y2="18" />
    <line x1="18" y1="6" x2="6" y2="18" />
  </svg>
);

export const Fullscreen: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="4 9 4 4 9 4" />
    <polyline points="20 9 20 4 15 4" />
    <polyline points="4 15 4 20 9 20" />
    <polyline points="20 15 20 20 15 20" />
  </svg>
);

export const ExitFullscreen: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 4 9 9 4 9" />
    <polyline points="15 4 15 9 20 9" />
    <polyline points="9 20 9 15 4 15" />
    <polyline points="15 20 15 15 20 15" />
  </svg>
);

export const Cube: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3 L21 7.5 L21 16.5 L12 21 L3 16.5 L3 7.5 Z" />
    <path d="M3 7.5 L12 12 L21 7.5" />
    <line x1="12" y1="12" x2="12" y2="21" />
  </svg>
);

export const CloudHouse: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <ellipse cx="12" cy="19" rx="8" ry="2.4" />
    <path d="M12 5 L18 8 L18 13.5 L12 16.5 L6 13.5 L6 8 Z" />
    <path d="M6 8 L12 11 L18 8" />
    <path d="M12 11 L12 16.5" />
  </svg>
);

export const Route: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="6" cy="6" r="2.5" />
    <circle cx="18" cy="18" r="2.5" />
    <path d="M8.5 6 H14 a4 4 0 0 1 0 8 H10 a4 4 0 0 0 0 8 h5.5" />
  </svg>
);

export const CheckBadge: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2 L14.6 4.2 L18 3.7 L18.9 7 L21.6 9 L20.4 12.2 L21.6 15.4 L18.9 17.4 L18 20.7 L14.6 20.2 L12 22.4 L9.4 20.2 L6 20.7 L5.1 17.4 L2.4 15.4 L3.6 12.2 L2.4 9 L5.1 7 L6 3.7 L9.4 4.2 Z" />
    <polyline points="8.5 12 11 14.5 15.5 9.5" />
  </svg>
);

export const Pool: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 4 V14" />
    <path d="M16 4 V14" />
    <line x1="8" y1="8.5" x2="16" y2="8.5" />
    <path d="M3 17 q2 -1.5 4 0 t4 0 t4 0 t4 0 t4 0" />
    <path d="M3 20 q2 -1.5 4 0 t4 0 t4 0 t4 0 t4 0" />
  </svg>
);

export const Bed: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 17 V8" />
    <path d="M21 17 V13" />
    <path d="M3 13 H21" />
    <path d="M3 17 H21" />
    <path d="M7 13 V10 a1 1 0 0 1 1 -1 h3 a1 1 0 0 1 1 1 v3" />
  </svg>
);

export const Area: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="14 4 20 4 20 10" />
    <polyline points="10 20 4 20 4 14" />
    <line x1="20" y1="4" x2="13" y2="11" />
    <line x1="4" y1="20" x2="11" y2="13" />
  </svg>
);

export const Binoculars: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="6" cy="16" r="3" />
    <circle cx="18" cy="16" r="3" />
    <path d="M6 13 V7 h3 v3 h6 V7 h3 v6" />
    <line x1="9" y1="10" x2="15" y2="10" />
  </svg>
);

export const School: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 10 L12 5 L21 10 L12 15 Z" />
    <path d="M6 11.5 V17 c0 1 3 2 6 2 s6 -1 6 -2 V11.5" />
    <line x1="21" y1="10" x2="21" y2="15" />
  </svg>
);

export const Shield: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3 L20 6 V11 c0 5 -3.5 8.5 -8 10 c-4.5 -1.5 -8 -5 -8 -10 V6 Z" />
    <polyline points="9 12 11.5 14.5 15.5 10" />
  </svg>
);

export const Calendar: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3.5" y="5" width="17" height="16" rx="2" />
    <line x1="3.5" y1="9.5" x2="20.5" y2="9.5" />
    <line x1="8" y1="3" x2="8" y2="6.5" />
    <line x1="16" y1="3" x2="16" y2="6.5" />
    <rect x="7" y="13" width="3" height="3" rx="0.5" fill="currentColor" stroke="none" />
  </svg>
);

export const Share: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="18" cy="5" r="2.6" />
    <circle cx="6" cy="12" r="2.6" />
    <circle cx="18" cy="19" r="2.6" />
    <line x1="8.3" y1="10.7" x2="15.7" y2="6.3" />
    <line x1="8.3" y1="13.3" x2="15.7" y2="17.7" />
  </svg>
);

export const Copy: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <rect x="9" y="9" width="11" height="11" rx="2" />
    <path d="M5 15 a2 2 0 0 1 -2 -2 V5 a2 2 0 0 1 2 -2 h8 a2 2 0 0 1 2 2" />
  </svg>
);

export const Check: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const Link: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 13a5 5 0 0 0 7.07 0l2.83-2.83a5 5 0 0 0-7.07-7.07L11 4.93" />
    <path d="M14 11a5 5 0 0 0-7.07 0L4.1 13.83a5 5 0 0 0 7.07 7.07L13 19.07" />
  </svg>
);

export const Mail: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3.5 6.5 L12 13 L20.5 6.5" />
  </svg>
);

export const WhatsApp: IconC = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2a10 10 0 0 0-8.6 15l-1.3 4.7 4.8-1.3A10 10 0 1 0 12 2zm0 1.8a8.2 8.2 0 0 1 6.9 12.6 8.2 8.2 0 0 1-10.6 2.8l-.34-.2-2.85.75.76-2.78-.22-.36A8.2 8.2 0 0 1 12 3.8zm-3 3.4c-.16 0-.42.06-.64.3-.22.24-.85.83-.85 2.02 0 1.2.87 2.35 1 2.51.12.16 1.7 2.7 4.2 3.68 2.07.82 2.5.66 2.95.62.45-.04 1.45-.6 1.65-1.17.2-.58.2-1.07.14-1.18-.06-.1-.22-.16-.46-.28-.24-.12-1.45-.72-1.67-.8-.22-.08-.39-.12-.55.12-.16.24-.63.8-.77.96-.14.16-.28.18-.52.06-.24-.12-1.03-.38-1.96-1.21-.72-.64-1.21-1.44-1.35-1.68-.14-.24-.01-.37.1-.49.11-.11.24-.28.36-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.54-1.32-.76-1.8-.18-.42-.37-.42-.55-.43h-.46z" />
  </svg>
);

export const Qr: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <line x1="14" y1="14" x2="14" y2="17" />
    <line x1="17.5" y1="14" x2="17.5" y2="14" />
    <line x1="21" y1="14" x2="21" y2="18" />
    <line x1="14" y1="21" x2="18" y2="21" />
    <line x1="21" y1="21" x2="21" y2="21" />
  </svg>
);

export const Building: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 21 V6 a1 1 0 0 1 1 -1 h6 a1 1 0 0 1 1 1 v15" />
    <path d="M12 21 V11 a1 1 0 0 1 1 -1 h5 a1 1 0 0 1 1 1 v10" />
    <line x1="3" y1="21" x2="21" y2="21" />
    <line x1="7" y1="8.5" x2="9" y2="8.5" />
    <line x1="7" y1="12" x2="9" y2="12" />
    <line x1="7" y1="15.5" x2="9" y2="15.5" />
    <line x1="15" y1="13.5" x2="16" y2="13.5" />
    <line x1="15" y1="17" x2="16" y2="17" />
  </svg>
);

export const PDF: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 3 H7 a2 2 0 0 0 -2 2 v14 a2 2 0 0 0 2 2 h10 a2 2 0 0 0 2 -2 V8 Z" />
    <polyline points="14 3 14 8 19 8" />
    <text x="8" y="17" fontSize="5" fontFamily="Inter" fontWeight="700" fill="currentColor" stroke="none">PDF</text>
  </svg>
);

export const Download: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 4 V15" />
    <polyline points="8 11 12 15 16 11" />
    <line x1="4" y1="19" x2="20" y2="19" />
  </svg>
);

export const Plus: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="6" y1="12" x2="18" y2="12" />
    <line x1="12" y1="6" x2="12" y2="18" />
  </svg>
);

export const Minus: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="6" y1="12" x2="18" y2="12" />
  </svg>
);

export const Play: IconC = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <polygon points="8 5 19 12 8 19" />
  </svg>
);

export const Bird: IconC = () => (
  <svg viewBox="0 0 32 12" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 8 Q 8 1, 14 6 Q 18 1, 24 7 Q 27 5, 30 8" />
  </svg>
);

export const Pencil: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
  </svg>
);

/* Category icons for the Location POI panel (Tech Parks · Schools · Hospitals · Malls · Transit · Landmarks). */
export const TechPark: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3.5" y="9" width="6.5" height="11" rx="1" />
    <rect x="14" y="4" width="6.5" height="16" rx="1" />
    <line x1="5.5" y1="12" x2="8" y2="12" />
    <line x1="5.5" y1="15.5" x2="8" y2="15.5" />
    <line x1="16" y1="7" x2="18.5" y2="7" />
    <line x1="16" y1="10.5" x2="18.5" y2="10.5" />
    <line x1="16" y1="14" x2="18.5" y2="14" />
  </svg>
);

export const Hospital: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="6" width="16" height="14" rx="1.5" />
    <line x1="12" y1="9" x2="12" y2="16" />
    <line x1="8.5" y1="12.5" x2="15.5" y2="12.5" />
  </svg>
);

export const Mall: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 9 L6 5 H18 L20 9" />
    <path d="M4 9 V19 H20 V9" />
    <path d="M9 9 V12 a3 3 0 0 0 6 0 V9" />
  </svg>
);

export const Transit: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <rect x="6" y="3.5" width="12" height="14" rx="3" />
    <line x1="6" y1="11" x2="18" y2="11" />
    <circle cx="9" cy="14" r=".9" fill="currentColor" stroke="none" />
    <circle cx="15" cy="14" r=".9" fill="currentColor" stroke="none" />
    <line x1="8" y1="17.5" x2="6" y2="20.5" />
    <line x1="16" y1="17.5" x2="18" y2="20.5" />
  </svg>
);

export const Landmark: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 20 H21" />
    <path d="M5 20 V11" />
    <path d="M9 20 V11" />
    <path d="M15 20 V11" />
    <path d="M19 20 V11" />
    <path d="M3 11 H21" />
    <path d="M4.5 11 L12 4 L19.5 11" />
  </svg>
);

/* ── Share channel icons (Telegram / LinkedIn / SMS) ──
   Added alongside Mail / WhatsApp / Qr for the V3 share modal v2. */
export const Telegram: IconC = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M21.66 4.06 18.4 19.4c-.25 1.11-.92 1.37-1.86.85l-5.14-3.79-2.48 2.39c-.27.27-.5.5-1.04.5l.37-5.26 9.6-8.67c.42-.37-.09-.58-.65-.21l-11.87 7.47-5.11-1.6c-1.11-.34-1.13-1.11.23-1.64l19.96-7.71c.92-.34 1.73.22 1.43 1.62z"/>
  </svg>
);

export const LinkedIn: IconC = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14zM8 10H5v9h3v-9zm-1.5-4.5A1.75 1.75 0 1 0 6.5 9a1.75 1.75 0 0 0 0-3.5zM19 13.5c0-2.4-1.5-3.5-3.4-3.5a2.94 2.94 0 0 0-2.6 1.4V10h-3v9h3v-4.8c0-1.06.2-2.1 1.52-2.1 1.3 0 1.48 1.2 1.48 2.17V19h3v-5.5z"/>
  </svg>
);

export const Sms: IconC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
  </svg>
);
